import { apiClient } from './client'
import type { FeatureFlag, UpdateFeatureFlagPayload } from '@/types/featureFlag'

export const featureFlagsApi = {
  list: () => apiClient.get<FeatureFlag[]>('/admin/feature-flags').then((r) => r.data),

  update: (key: string, payload: UpdateFeatureFlagPayload) =>
    apiClient.patch<FeatureFlag>(`/admin/feature-flags/${key}`, payload).then((r) => r.data),
}
